import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface IUITextProps extends TypographyProps {
  children: any;
  fz?: number; // font-size alias
  fw?: number; // font-weight alias
  color?: string;
  variant?: TypographyProps['variant'];
  textAlign?: TypographyProps['textAlign'];
}

const UIText: React.FC<IUITextProps> = ({ children, fz, fw, ...props }) => {
  return (
    <Typography fontSize={fz} fontWeight={fw} fontFamily={'Onest'} {...props}>
      {children}
    </Typography>
  );
};

export default UIText;
